export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 16c3.094 0 6 2.042 6 5a1 1 0 01-1 1H10a1 1 0 01-1-1c0-2.958 2.906-5 6-5zm0 2c-1.87 0-3.231.913-3.759 2h7.518c-.528-1.087-1.889-2-3.759-2z\" fill=\"#7B61FF\"/><path d=\"M10 2.5a1 1 0 01.781.375L12.481 5H21l.102.005A1 1 0 0122 6v10.5h-2V7h-8a1 1 0 01-.781-.375L9.519 4.5H4v12h3.5v2H3a1 1 0 01-1-1v-14a1 1 0 011-1h7z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 9a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};